import { UserModel } from "utils/types";

import { SearchCriteria } from "store/eligibility/actions";
import { DownloadDocument } from "store/eligibility/gap/actions";
import { AttestationAcknowledgementRequest } from "./Modals";

export default interface QualityOverViewPageProps {
  CheckAttestationVisibility(userId: string, attestationName: string): any;
  AddAttestationAcknowledgement(userModel: any): any;
  DownloadAttestation(requestModel: AttestationAcknowledgementRequest): any;
  GetAttestationPopupContent(attestationName: string): any;
  getDownloadResources(filePath: string, companyId: string): any;
  search(searchCriteria: SearchCriteria): any;
  getAllDesc(): any;
  getContractedIPA(userId: string): any;
  getMedicareMetricsOverview(userId: string, pcpKeyId: string, ipaCode: string, measureYear: number, vendorId: string): any;
  getHistoricalRafScore(provId: string, companyId: string, userId: string, measureYear: number, vendorId: string): any;
  getAuthEnabledProviderList(userModel: UserModel): any;
  getProviderHedis(provKey: string, companyId: string, lob: string, measureYear: number, vendorId: string): any,
  getMembers(measureCode: string, provKey: string, companyId: string, lob: string, pageIndex: number, pageSize: number, measureYear: number, vendorId: string): any;
  getProviderReport(provKey: string, companyId: string, userId: string, rptType: string, measureYear: number, vendorId: string): any;
  getDownloadDocument(model: DownloadDocument): any;
  getProviderOverallPerformance(model: Object): any;
  getDistinct(userId: string): any;
  getDistinctVendors(provKeyId: string, companyId: string): any;
  printMembersReport(params: any): any;
  getMeasureReportPrintFile(params: any): any;
  downloadMemberFile(params: any): any;
  getForAlertsRow1(pcpKeyId: string, companyId: string, timeSpan: string, pageIndex: number, pageSize: number, vendorId: string): any;
  getAlertCount(pcpKeyId: string, companyId: string, timeSpan: string, vendorId: string): any;
  getProviderKeyListWDates(userId: string): any;
  isSearchingMembers: boolean;
  isFetchingMedicare: boolean;
  isFetchingHistoricalRafScore: boolean;
  isFetchingOverallPerformance: boolean;
  isFetchingHEDIS: boolean;
  isFetchingDistinct: boolean;
  isFetchingRow1: boolean;
  isCreatingGenProv: boolean;
  isFetchingMembers: boolean;
  isAddingAttestation: boolean;
  showUrgentAnnouncement(): any;

  //eligibility info page related
  search(searchCriteria: SearchCriteria): any;

  // Web pilot posting related
  getFaxOptOutExists(userId: string): any;
  bulkInsertFaxOptOutProviders(userModel: any): any;
  isCreatingWebPilotPosing: boolean;
}

export enum COLUMN_NAME {
  NEW_MEMBERS = 'NEW_MEMBERS',
  TERMED_MEMBERS = 'TERMED_MEMBERS',
  IHA_MEMBERS = 'IHA_MEMBERS',
  ALL = 'ALL'
}

export interface MeasureMember {
  RmiBirth: string;
  RmiCompanyID: string;
  RmiCompleted: string;
  RmiGender: string;
  RmiMemberID: string;
  RmiMemberName: string;
  RmiPhone: string;
};